import { createKeyMapping, type KeyMapping } from '@/libraries/common/minificationUtils'

export const FORMAT_VERSION = 1

/** Maps original key names to their minified short codes. */
export const KEY_MAP: Record<string, string> = {
  _id: '_id',
  type: 't',
  version: 'v',
  children: 'c',
  altText: 'at',
  backgroundColor: 'bg',
  checked: 'ck',
  colSpan: 'cs',
  detail: 'e',
  direction: 'd',
  format: 'f',
  headerState: 'hs',
  indent: 'i',
  listType: 'lt',
  mode: 'm',
  rel: 'rl',
  rowSpan: 'rs',
  size: 'sz',
  src: 'sr',
  start: 'st',
  style: 's',
  tag: 'g',
  target: 'tg',
  templateColumns: 'tc',
  text: 'x',
  textFormat: 'tf',
  textStyle: 'ts',
  title: 'ti',
  url: 'u',
  isUnlinked: 'ul',
  colWidths: 'cw',
  frozenColumnCount: 'fc',
  frozenRowCount: 'fr',
  rowStriping: 'r=',
  value: 'va',
  width: 'w',
  height: 'h',
  data: 'da',
  hash: 'sh',
  align: 'al',
}

export const LEXICAL_KEY_MAPPING: KeyMapping = createKeyMapping(KEY_MAP)
export const KEY_UNMAP: Record<string, string> = LEXICAL_KEY_MAPPING.unmap

if (process.env.NODE_ENV === 'development') {
  if ('V' in KEY_MAP) {
    console.error('KEY_MAP should not contain \'V\' as it is reserved for format versioning.')
  }
}

/** Maps known node type strings to their minified short codes. */
export const TYPE_MAPPING = createKeyMapping({
  root: 'ro',
  autolink: 'al',
  'checklist-item': 'ci',
  heading: 'h',
  image: 'im',
  'layout-container': 'lc',
  'layout-item': 'lI',
  linebreak: 'lb',
  link: 'lk',
  listitem: 'li',
  list: 'l',
  paragraph: 'p',
  'qr-code': 'qr',
  quote: 'q',
  tablecell: 'tc',
  tablerow: 'tr',
  table: 'ta',
  text: 'tx',
  'fabric-diagram': 'fd',
})
